import { gql } from '@apollo/client/core'

export const ROOM_APPOINTMENTS_EXPORT = gql`
  mutation rommAppointmentsExportSend(
    $startingDate: ISO8601DateTime!
    $endingDate: ISO8601DateTime!
  ) {
    roomAppointmentsExportSend(
      startingDate: $startingDate
      endingDate: $endingDate
    ) {
      result {
        status
        message
      }
    }
  }
`

export interface ExportVariables {
  startingDate: string,
  endingDate: string
}

export interface ExportResult {
  result: {
    message: string,
    status: string
  }
}

export const PARCELS_UNDELIVERED_EXPORT = gql`
  mutation parcelsNotInCustomerHandExportSend {
    parcelsNotInCustomerHandExportSend {
      result {
        status
        message
      }
    }
  }
`

export const POSTAL_LIST_EXPORT = gql`
  mutation postalListExportSend {
    postalListExportSend {
      result {
        status
        message
      }
    }
  }
`
